 AOS.init({
     startEvent: 'load',
     duration: 700,
     offset:50,
 
 });
 window.addEventListener('load', function() {
     AOS.refresh();
 });
 
 onElementHeightChange(document.body, function(){
     AOS.refresh();
 });
 function onElementHeightChange(elm, callback) {
     var lastHeight = elm.clientHeight
     var newHeight;
 
     (function run() {
         newHeight = elm.clientHeight;      
         if (lastHeight !== newHeight) callback();
         lastHeight = newHeight;
 
         if (elm.onElementHeightChangeTimer) {
             clearTimeout(elm.onElementHeightChangeTimer); 
         }
 
         elm.onElementHeightChangeTimer = setTimeout(run, 200);
     })();
 }


// equal height
!function n(t, r, e) { function i(u, f) { if (!r[u]) { if (!t[u]) { var c = "function" == typeof require && require; if (!f && c) return c(u, !0); if (o) return o(u, !0); throw new Error("Cannot find module '" + u + "'") } var a = r[u] = { exports: {} }; t[u][0].call(a.exports, function (n) { var r = t[u][1][n]; return i(r || n) }, a, a.exports, n, t, r, e) } return r[u].exports } for (var o = "function" == typeof require && require, u = 0; u < e.length; u++)i(e[u]); return i }({ 1: [function (n, t, r) { !function (n) { function t() { var t, r = n("[data-eq]").map(function () { return n(this).data("eq") }).get(); (t = {}, r.forEach(function (n) { t[n + "::" + typeof n] = n }), Object.keys(t).map(function (n) { return t[n] })).forEach(function (t) { var r = 0; n('[data-eq="' + t + '"]').css("min-height", "").each(function () { n(this).outerHeight() > r && (r = n(this).outerHeight()) }).css("min-height", r + "px") }) } n(window).on("load", function () { t() }), n(window).resize(function () { t() }) }(jQuery) }, {}] }, {}, [1]);

//Loader
$(window).on('load', function() {
//$('#status').fadeOut();
$('#preloader').delay(150).fadeOut('fast'); 
$('body').delay(50).css({'overflow':'visible'});
})


//Lazy Loading
 if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.src = img.src;
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src =
      'js/lazysizes.min.js';
    document.body.appendChild(script);
  }


//Home Hero Slider
 const swiper = new Swiper('.heroSwiper', {
      loop: true,
      speed: 2000,
      parallax: true,
      autoplay: false,
      grabCursor: false,
      pagination: {
        //el: '.swiper-pagination',
        //clickable: true,
        // horizontalClass: 'vertical-right-center'
      },
       navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

//hommage Hero Slider
 const swiper2 = new Swiper('.hommageSwiper', {
      loop: true,
      speed: 2000,
      parallax: true,
      autoplay: false,
      grabCursor: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        // horizontalClass: 'vertical-right-center'
      },
  });


$(".brand-slider").slick({
  slidesToShow: 6,
  infinite:true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
  responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ]
});

$(".new-arrival-slider").slick({
  infinite:true,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: false,
  arrows: false,
  slidesToScroll: 1,
  slidesToShow: 2,
  arrows: false,
  focusOnSelect: true,
  responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
});


$(".insights-slider").slick({
  infinite:true,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
  arrows: true,
  slidesToScroll: 1,
  slidesToShow: 3,
  prevArrow: $('.prev'),
  nextArrow: $('.next'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
});


$(".customer-review-slider").slick({
  slidesToShow: 3,
  infinite:true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
});


$(".gift-card-slider").slick({
  infinite:true,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: false,
  arrows: false,
  slidesToScroll: 1,
  slidesToShow: 1,
  arrows: false,
  fade:false,
  autoplay: true,
  autoplaySpeed: 2000,
});

if ( $('.prive-slider').length > 0) {
    var $slider = $('.prive-slider');
    var $navLinks = $('.subNav');

    // Initialize slick
    $slider.slick({
      slidesToShow: 3,
      infinite: true,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });

    // Set active nav on init
    setActiveNav(0);

    // Update active class on slide change
    $slider.on('afterChange', function (event, slick, currentSlide) {
      setActiveNav(currentSlide);
    });

    // On nav click, go to slide
    $navLinks.on('click', function (e) {
      e.preventDefault();
      const index = $(this).data('slide') - 1;
      $slider.slick('slickGoTo', index);
    });

    function setActiveNav(index) {
      $navLinks.removeClass('active');
      $navLinks.eq(index).addClass('active');
    }
  
}

// Floating Labels
$('.ffl-wrapper').floatingFormLabels(); 


//Scroll to Menu
function scrollNav() {
$('.servicesBx').click(function(){ 
  //Animate
  $('html, body').stop().animate({
      scrollTop: $( $(this).attr('href') ).offset().top - 200
  }, 900);
  return false;
});
}
scrollNav();


 $('#imageGallery').lightSlider({
     gallery:true,
     item:1,
     loop:false,
     thumbItem:2,
     enableDrag: false,
     // currentPagerPosition:'left',
     onSliderLoad: function(el) {
        el.lightGallery({
            selector: '#imageGallery .lslide'
        });
     }   
 });  

$('.cart_quantityWrp_Btn').click(function(){
     var input = $(this).siblings('.cart_quantityWrp_Inp');
     var currentVal = parseInt(input.val()) || 0;
     input.val(currentVal + 1);
 });


document.querySelectorAll('a.subNav[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));
        const headerOffset = document.querySelector('header').offsetHeight + 130; // height of fixed header
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    });
});

window.addEventListener('load', function () {
    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
            const headerOffset = document.querySelector('header').offsetHeight + 20;
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }
});
